export enum EErrorMessage {
    DEFAULT = '',
    SESSION_EXPIRED = 'Hey there!\nSorry for the interruption, but it appears that your session has expired.\nWe will be reloading the page shortly, and you may have to re-authenticate yourself.\nCheers!',
    INIT_FAILED = 'Hey there!\n Sorry but it seems like our application failed to initialise.\nWe will be retrying again shortly.\nIf this problem persists, please reach out to us via any of the channels!',
}
